export const GemMark = ({ className = "h-8 w-8" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="gemg" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#FDE047" />
        <stop offset="1" stopColor="#F59E0B" />
      </linearGradient>
    </defs>
    <path d="M32 6 L54 24 L32 58 L10 24 Z" fill="url(#gemg)" />
    <path d="M10 24 L54 24 M32 6 L23 24 L32 58 L41 24 Z" fill="none" stroke="#0B0F17" strokeWidth="2.4" strokeLinejoin="round" />
  </svg>
);

export const Logo = ({ onClick }) => (
  <a href="/" onClick={onClick} data-testid="nav-logo" className="group flex items-center gap-2.5">
    <GemMark className="h-8 w-8 transition-transform duration-500 group-hover:rotate-[18deg]" />
    <span className="font-display text-lg font-bold leading-none tracking-tight text-white">
      Citrine<span className="block font-mono-x text-[10px] font-normal uppercase tracking-[0.3em] text-amber-300">Home Solutions</span>
    </span>
  </a>
);
